import React, {Fragment, ReactNode} from 'react';
import * as cls from './css/FigureLayout.css';

export function FigureLayout(props: {
    children: ReactNode;
    heading: JSX.Element | string;
    details: JSX.Element | string;
}) {
    return (
        <Fragment>
            <figure className={`${cls.figure} mb-6`}>{props.children}</figure>
            <hgroup className='grid gap-4 pt-2 text-center'>
                <h2 className='fv-heading-l whitespace-break-spaces text-neutral-100'>{props.heading}</h2>
                <small className='fv-text-l-regular text-neutral-90'>{props.details}</small>
            </hgroup>
        </Fragment>
    );
}

export namespace FigureLayout {
    export const Picture = (props: {webp: string; avif: string}) => (
        <picture className='flex max-w-full justify-center'>
            <source srcSet={props.avif} type='image/avif' />
            <img src={props.webp} height='100%' width='auto' alt='' />
        </picture>
    );
    Picture.displayName = 'FigureLayout.Picture';
}
